import React, { FC } from 'react'
import styled, { css } from 'styled-components'
import { Link } from '@ads/front-core/atoms'
import { lng } from '@ads/front-core/locales'
import { TabCard } from './interfaces'

interface ITabsCardItem {
  isSelected: boolean
  tab: TabCard
}

type TabStyledProps = {
  isActive: boolean
  isDisabled?: boolean
}

export const TabsCardItem: FC<ITabsCardItem> = ({ isSelected, tab }) =>
  tab.url ? (
    <TabLink
      isActive={isSelected}
      isDisabled={tab.isDisabled}
      to={tab.isDisabled ? null : tab.url}
    >
      {tab.Icon ? <tab.Icon /> : null}
      {lng(tab.label)}
    </TabLink>
  ) : (
    <Tab
      isActive={isSelected}
      isDisabled={tab.isDisabled}
      onClick={tab.isDisabled ? null : tab.onClick}
    >
      {tab.Icon ? <tab.Icon /> : null}
      {lng(tab.label)}
    </Tab>
  )

const TabBase = css<TabStyledProps>`
  ${p => css`
    cursor: pointer;
    padding: ${p.theme.space.s}px ${p.theme.space.m}px;
    font-weight: ${p.theme.fontWeights.medium};
    font-size: ${p.theme.fontSizes.m}px;
    color: ${p.isDisabled
      ? p.theme.colors.greyDisabled
      : p.isActive
      ? p.theme.colors.grey100
      : p.theme.colors.primary50};
    background: transparent;
    outline: none;
    border: ${p.theme.borders.thinGrey20};
    border-bottom: none;
    border-color: transparent;
    margin-bottom: -1px;
    display: flex;
    flex-flow: row;
    align-items: center;
    gap: ${p.theme.space.xxs}px;

    ${p.isActive &&
    css`
      background: ${p.theme.colors.inverted100};
      border-color: ${p.theme.colors.grey20};
      border-radius: ${p.theme.space.xxxs}px ${p.theme.space.xxxs}px 0 0;
    `}
  `}
`

const TabLink = styled(Link)<TabStyledProps>`
  ${TabBase}
`

const Tab = styled.div<TabStyledProps>`
  ${TabBase}
`
